import React from 'react';

const Bilde = ({url, className, heroimage}) => {


    return (
        <>
            {heroimage }
            <img src={url} alt="" className={className}/>
        </>
    );
}


export default Bilde;

